<template>
  <main>
    <div v-html="contenthtml"></div>
  </main>
</template>
<script>
export default {
  data() {
    return {
      contenthtml: "",
    };
  },
  computed: {},
  mounted() {
    // Llama a una función para procesar el código
    this.processDynamicContent();
  },
  methods: {
    decod() {
      return atob(this.$route.params.form);
    },
    processDynamicContent() {
      let fullCode = this.decod();
      // Utiliza una expresión regular o algún otro método para separar HTML y JavaScript
      //const regex = '/<script[^>]*?>([\s\S]*?)<\/script>/';
      const regex =
        /<script[^>]*?language=["']?Javascript["']?[^>]*?>([\s\S]*?)<\/script>/i;

      const match = fullCode.match(regex);

      if (match) {
        const htmlContent = fullCode.replace(regex, "");
        const javascriptCode = match[1];
        // Inserta el HTML
        this.contenthtml = htmlContent;

        // Ejecuta el JavaScript después de que el componente se haya montado
        this.$nextTick(() => {
          try {
            // Evalúa el código JavaScript
            eval(javascriptCode);
          } catch (error) {
            // console.error("Error al ejecutar el código JavaScript:", error);
          }
        });
      } else {
        // console.log("NO MARCH ");
        // Si no se encuentra código JavaScript, solo inserta el HTML
        this.contenthtml = fullCode;
      }
    },
  },
};
</script>
